(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
  "use strict";
  
  var _scrollAnimation = _interopRequireDefault(require("./components/scrollAnimation.js"));
  var _scrollHeader = _interopRequireDefault(require("./components/scrollHeader.js"));
  var _anchorLink = _interopRequireDefault(require("./components/anchorLink.js"));
  var _ohtaniShopList = _interopRequireDefault(require("./components/ohtaniShopList.js"));
  var _ohtaniArchive = _interopRequireDefault(require("./components/ohtaniArchive.js"));
  var _ohtaniModal = _interopRequireDefault(require("./components/ohtaniModal.js"));
  var _ohtaniOrder = _interopRequireDefault(require("./components/ohtaniOrder.js"));
  var _ohtaniLegend = _interopRequireDefault(require("./components/ohtaniLegend.js"));
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  gsap.registerPlugin(ScrollTrigger);
  var anchorLink = new _anchorLink["default"]();
  var scrollAnimation = new _scrollAnimation["default"]();
  var scrollHeader = new _scrollHeader["default"]();
  var ohtaniShopList = new _ohtaniShopList["default"]();
  var ohtaniArchive = new _ohtaniArchive["default"]();
  var ohtaniModal = new _ohtaniModal["default"]();
  var ohtaniOrder = new _ohtaniOrder["default"]();
  var ohtaniLegend = new _ohtaniLegend["default"]();
  
  },{"./components/anchorLink.js":2,"./components/headerToggle.js":3,"./components/ohtaniArchive.js":4,"./components/ohtaniLegend.js":5,"./components/ohtaniModal.js":6,"./components/ohtaniOrder.js":7,"./components/ohtaniShopList.js":8,"./components/scrollAnimation.js":9,"./components/scrollHeader.js":10}],2:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var AnchorLink = exports["default"] = /*#__PURE__*/function () {
    function AnchorLink() {
      _classCallCheck(this, AnchorLink);
      this.init();
    }
    return _createClass(AnchorLink, [{
      key: "init",
      value: function init() {
        var _this = this;
        var linkEl = document.querySelectorAll('a[href^="#"]');
        if (!linkEl) return;
        var linkElArray = Array.prototype.slice.call(linkEl, 0);
        linkElArray.forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var targetID = link.getAttribute('href').slice(1);
            var targetEl = document.getElementById(targetID);
            var buffer = 0;
            if (link.classList.contains('js-article-detail-index')) {
              buffer = 100;
            }
            _this.smoothScrollToTargetPosition(e, link, buffer);
            return false;
          });
        });
      }
  
      /**
       * アニメーションつきスクロール
       */
    }, {
      key: "smoothScrollToTargetPosition",
      value: function smoothScrollToTargetPosition(e) {
        var respond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var buffer = arguments.length > 2 ? arguments[2] : undefined;
        var distanceToTop = function distanceToTop(el) {
          return Math.floor(el.getBoundingClientRect().top - buffer);
        };
        e.preventDefault();
        var targetID = respond ? respond.getAttribute('href') : this.getAttribute('href');
        var targetAnchor = document.querySelector(targetID);
        if (!targetAnchor) return;
        var originalTop = distanceToTop(targetAnchor);
        window.scrollBy({
          top: originalTop,
          left: 0,
          behavior: 'smooth'
        });
        console.log('Smooth Scroll / Buffer: ' + buffer);
      }
    }]);
  }();
  
  },{}],3:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  
  },{}],4:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ohtaniArchive = exports["default"] = /*#__PURE__*/function () {
    function ohtaniArchive() {
      _classCallCheck(this, ohtaniArchive);
      if (!document.querySelector(".main-wrapper--ohtani")) return;
      this.slideInit();
    }
    return _createClass(ohtaniArchive, [{
      key: "slideInit",
      value: function slideInit() {
        var boxes = document.querySelectorAll('.archive__items.splide');
        if (boxes) {
          var _iterator = _createForOfIteratorHelper(boxes),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var box = _step.value;
              new Splide(box, {
                type: 'loop',
                perPage: 3,
                perMove: 3,
                gap: 30,
                rewind: false,
                arrows: true,
                pagination: false,
                breakpoints: {
                  767: {
                    perPage: 1,
                    perMove: 1,
                    arrows: false,
                    pagination: true,
                    gap: 0
                  }
                }
              }).mount();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
    }]);
  }();
  
  },{}],5:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ohtaniLegend = exports["default"] = /*#__PURE__*/function () {
    function ohtaniLegend() {
      _classCallCheck(this, ohtaniLegend);
      if (!document.querySelector(".main-wrapper--ohtani")) return;
      this.animeInit();
    }
    return _createClass(ohtaniLegend, [{
      key: "animeInit",
      value: function animeInit() {
        var target = document.querySelector('.legend');
        ScrollTrigger.create({
          trigger: target,
          start: 'top top',
          onEnter: function onEnter() {
            target.classList.add('is_anime');
          }
        });
        var target2 = document.querySelector('.legend2__texts');
        ScrollTrigger.create({
          trigger: target2,
          start: 'top center',
          onEnter: function onEnter() {
            target2.classList.add('is_anime');
          }
        });
      }
    }]);
  }();
  
  },{}],6:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  // var ohtaniModal = exports["default"] = /*#__PURE__*/function () {
  //   function ohtaniModal() {
  //     _classCallCheck(this, ohtaniModal);
  //     if (!document.querySelector(".main-wrapper--ohtani")) return;
  //     this.modalToggle();
  //     this.closeModal();
  //     this.header = document.querySelector(".header");
  //   }
  //   return _createClass(ohtaniModal, [{
  //     key: "modalToggle",
  //     value: function modalToggle() {
  //       var _this = this;
  //       var items = document.querySelectorAll(".product__item");
  //       items.forEach(function (item) {
  //         var button = item.querySelector(".product__open");
  //         button.addEventListener("click", function (event) {
  //           var modal = item.querySelector(".product__modal");
  //           modal.classList.toggle("is_open");
  //           _this.header.classList.toggle("header--isHide");
  //           _this.fixed(modal);
  //         });
  //       });

  //       // for ARCHIVE
  //       var archiveItems = document.querySelectorAll('.archive__item')
  //       archiveItems.forEach(function(item){
  //         var button = item.querySelector('.archive__item-button')
  //         button.addEventListener('click', function(event){
  //           var archiveModalEl = document.querySelector('.archive__modal')
  //           archiveModalEl.innerHTML = ''
  //           var modal = item.querySelector(".product__modal").cloneNode(true)
  //           archiveModalEl.appendChild(modal)
  //           modal.classList.toggle("is_open");
  //           _this.header.classList.toggle("header--isHide");
  //           _this.fixed(modal);
  //           _this.closeModal()
  //         })
  //       })
  //     }
  //   }, {
  //     key: "closeModal",
  //     value: function closeModal() {
  //       var _this2 = this;
  //       var closeButtons = document.querySelectorAll(".product__modal-close");
  //       var closeBg = document.querySelectorAll(".product__modal-bg");
  //       closeButtons.forEach(function (button) {
  //         button.addEventListener("click", function (event) {
  //           event.preventDefault();
  //           var modal = event.target.closest(".product__modal");
  //           if (modal) {
  //             modal.classList.remove("is_open");
  //             _this2.header.classList.toggle("header--isHide");
  //             _this2.fixed(modal);
  //           }
  //         });
  //       });
  //       closeBg.forEach(function (button) {
  //         button.addEventListener("click", function (event) {
  //           event.preventDefault();
  //           var modal = event.target.closest(".product__modal");
  //           if (modal) {
  //             modal.classList.remove("is_open");
  //             _this2.header.classList.toggle("header--isHide");
  //             _this2.fixed(modal);
  //           }
  //         });
  //       });
  //     }
  //   }, {
  //     key: "fixed",
  //     value: function fixed(modal) {
  //       document.documentElement.style.setProperty("--scroll-y", "".concat(window.scrollY, "px"));
  //       if (modal.classList.contains("is_open")) {
  //         var scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
  //         var body = document.body;
  //         document.body.style.position = "fixed";
  //         body.style.top = "-".concat(scrollY);
  //       } else {
  //         var _body = document.body;
  //         var _scrollY = _body.style.top;
  //         _body.style.top = "";
  //         _body.style.position = "";
  //         window.scrollTo(0, parseInt(_scrollY || "0") * -1);
  //       }
  //     }
  //   }]);
  // }();
  var ohtaniModal = exports["default"] = /*#__PURE__*/function () {
    function ohtaniModal() {
      _classCallCheck(this, ohtaniModal);
      if (!document.querySelector(".main-wrapper--ohtani")) return;
      this.header = document.querySelector(".header");
      this.modalToggle();
      this.closeModal();
    }
    return _createClass(ohtaniModal, [{
      key: "modalToggle",
      value: function modalToggle() {
        var _this = this;
        var items = document.querySelectorAll(".product__item");
        items.forEach(function (item) {
          var button = item.querySelector(".product__open");
          if (!button) return;
          button.addEventListener("click", function (event) {
            var modal = item.querySelector(".product__modal");
            if (!modal) return;
            modal.classList.toggle("is_open");
            if (_this.header) _this.header.classList.toggle("header--isHide");
            _this.fixed(modal);
          });
        });

        // for ARCHIVE
        var archiveItems = document.querySelectorAll('.archive__item');
        archiveItems.forEach(function(item){
          var button = item.querySelector('.archive__item-button');
          if (!button) return;
          button.addEventListener('click', function(event){
            var archiveModalEl = document.querySelector('.archive__modal');
            if (!archiveModalEl) return;
            archiveModalEl.innerHTML = '';
            var modalSource = item.querySelector(".product__modal");
            if (!modalSource) return;
            var modal = modalSource.cloneNode(true);
            archiveModalEl.appendChild(modal);
            modal.classList.toggle("is_open");
            if (_this.header) _this.header.classList.toggle("header--isHide");
            _this.fixed(modal);
            _this.closeModal();
          });
        });
      }
    }, {
      key: "closeModal",
      value: function closeModal() {
        var _this2 = this;
        var closeButtons = document.querySelectorAll(".product__modal-close");
        var closeBg = document.querySelectorAll(".product__modal-bg");
        
        var handleClose = function(event) {
          event.preventDefault();
          var modal = event.target.closest(".product__modal");
          if (modal && modal.classList.contains("is_open")) {
            modal.classList.remove("is_open");
            if (_this2.header) _this2.header.classList.remove("header--isHide");
            _this2.fixed(modal);
          }
        };

        closeButtons.forEach(function (button) {
          button.addEventListener("click", handleClose);
        });
        closeBg.forEach(function (button) {
          button.addEventListener("click", handleClose);
        });
      }
    }, {
      key: "fixed",
      value: function fixed(modal) {
        var body = document.body;
        var html = document.documentElement;

        if (modal.classList.contains("is_open")) {
          // モーダルを開くとき: 現在のスクロール位置を記録して body を固定
          this.currentScrollY = window.scrollY || window.pageYOffset;
          body.style.position = "fixed";
          body.style.top = "-".concat(this.currentScrollY, "px");
          body.style.width = "100%";
        } else {
          // モーダルを閉じるとき: Smoothスクロールを一時的に無効化
          html.style.scrollBehavior = "auto";

          // body の固定を解除して元の位置へ復元
          var scrollY = this.currentScrollY || 0;
          body.style.position = "";
          body.style.top = "";
          body.style.width = "";
          window.scrollTo(0, scrollY);

          // 一時的に外した scrollBehavior を元の設定（CSS）に戻す
          html.style.scrollBehavior = "";
        }
      }
    }]);
  }();
  
  },{}],7:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ohtaniOrder = exports["default"] = /*#__PURE__*/function () {
    function ohtaniOrder() {
      _classCallCheck(this, ohtaniOrder);
      if (!document.querySelector(".main-wrapper--ohtani")) return;
      this.heightSet();
    }
    return _createClass(ohtaniOrder, [{
      key: "heightSet",
      value: function heightSet() {
        if (window.matchMedia('(max-width: 767px)').matches) {
          var order = document.querySelector(".product__order.sp-only");
          if (order) {
            var height = order.offsetHeight;
            document.documentElement.style.setProperty('--orderHeight', "".concat(height, "px"));
          }
        }
      }
    }]);
  }();
  
  },{}],8:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ohtaniShopList = exports["default"] = /*#__PURE__*/function () {
    function ohtaniShopList() {
      _classCallCheck(this, ohtaniShopList);
      if (!document.querySelector(".main-wrapper--ohtani")) return;
      this.shopOpen();
    }
    return _createClass(ohtaniShopList, [{
      key: "shopOpen",
      value: function shopOpen() {
        var shopItems = document.querySelectorAll(".shop__item");
        var _iterator = _createForOfIteratorHelper(shopItems),
          _step;
        try {
          var _loop = function _loop() {
            var item = _step.value;
            var title = item.querySelector(".shop__item-title");
            var listInner = item.querySelector(".shop__item-title + .shop__list .shop__list-inner");
            var list = item.querySelector(".shop__item-title + .shop__list");
            title.addEventListener("click", function () {
              if (title.classList.contains("is_open")) {
                title.classList.remove("is_open");
                list.style.setProperty("--shop-list-height", "0px"); // 高さを0に戻す
              } else {
                title.classList.add("is_open");
                var height = listInner.offsetHeight;
                list.style.setProperty("--shop-list-height", "".concat(height, "px"));
              }
            });
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }]);
  }();
  
  },{}],9:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var ScrollAnimation = exports["default"] = /*#__PURE__*/function () {
    function ScrollAnimation() {
      _classCallCheck(this, ScrollAnimation);
      this.scrollAnimeObserver();
      this.visibleAnimElemOnLoad();
    }
    /**
    * 領域内に入ってきた要素にクラスを付与する。
    */
    return _createClass(ScrollAnimation, [{
      key: "scrollAnimeObserver",
      value: function scrollAnimeObserver() {
        var aniBoxes = [].slice.call(document.querySelectorAll('.u-anime'));
        var options = {
          root: null,
          rootMargin: '0px 0px -15% 0px'
        };
        var aniBoxObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var cont = entry.target;
              var anim = cont.dataset.anim;
              if (!anim) {
                anim = "is_anime";
              }
              if (cont.classList.contains(anim) === false) {
                cont.classList.add(anim);
              }
              aniBoxObserver.unobserve(cont);
            }
          });
        }, options);
        aniBoxes.forEach(function (aniBox) {
          aniBoxObserver.observe(aniBox);
        });
      }
  
      /**
      * ページロード時に現在位置より上にある要素のアニメーションを完了させる。
      */
    }, {
      key: "visibleAnimElemOnLoad",
      value: function visibleAnimElemOnLoad() {
        var aniBoxes = [].slice.call(document.querySelectorAll('.u-anime'));
        aniBoxes.forEach(function (el) {
          var pos = el.getBoundingClientRect().top;
          var anim = el.dataset.anim;
          if (!anim) {
            anim = "is_anime";
          }
          if (pos < 0) {
            el.classList.add(anim);
          }
        });
      }
    }]);
  }();
  
  },{}],10:[function(require,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
  function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
  function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  var scrollHeader = exports["default"] = /*#__PURE__*/function () {
    function scrollHeader() {
      _classCallCheck(this, scrollHeader);
      if (!document.querySelector('.header')) return;
      this.scrollCheck();
    }
    return _createClass(scrollHeader, [{
      key: "scrollCheck",
      value: function scrollCheck() {
        var header = document.querySelector('.header');
        var headerHeight = header.offsetHeight;
        var startPos = 0;
        window.addEventListener('scroll', function () {
          var scrollPos = window.scrollY;
          if (scrollPos > startPos && scrollPos > headerHeight && scrollPos > 500) {
            header.classList.add('header--isScroll');
          } else {
            header.classList.remove('header--isScroll');
          }
          startPos = scrollPos;
        });
      }
    }]);
  }();
  
  },{}]},{},[1]);
  